// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yTgJ4","col":"styles_col__2EOUE"};